import { h, render } from 'preact';
import QuickView from './quick-view';

export default (element, data) => {
  const init = () => {
    render(<QuickView data={data} />, element);
  };

  init();
};
